const formatItems = itemsArr => {
  return itemsArr.map(item => ({
    value: item.id,
    label: item.label,
    id: item.id,
  }));
};

export default formatItems;
